import { PATH } from '#const/path';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';
import { useOnBoardStep } from './OnBoardStep.hooks';

import Progress from './components/Progress';
import Step1 from './components/Step1';
import Step2 from './components/Step2';
import Step3 from './components/Step3/page';
import Step4 from './components/Step4/page';
import Step5 from './components/Step5';
import Step6 from './components/Step6';
import Step7 from './components/Step7';
import Step8 from './components/Step8';
import Step9 from './components/Step9';
import * as S from './styles';
import { XButton } from '#assets/svg';
import ModalConfirm from '#molecules/ModalConfirm';

export function OnBoardStep() {
  const navigate = useNavigate();
  const { setStep, onBoardState } = useOnBoardStep();
  const [isOpen, setIsOpen] = useState(false);

  const onPrev = useCallback(() => {
    const { feature, step } = onBoardState;

    if (feature === '기본기능' && step === 8) {
      setStep(3);
      return;
    }

    if (onBoardState.step > 1) {
      setStep(onBoardState.step - 1);
      return;
    }

    navigate({ pathname: PATH.ONBOARD }, { replace: true });
  }, [onBoardState.step, setStep]);

  const onClose = () => {
    setIsOpen(false);
  };
  return (
    <>
      <PrevHeaderBarWithTitleTemplate
        title=""
        hasBorder={false}
        onPrev={onPrev}
        ContainerStyle={{ position: 'relative' }}
        defaultBackground
        rightContents={
          <XButton
            onClick={e => {
              e.stopPropagation();
              setIsOpen(true);
            }}
          />
        }
      >
        <Progress />
        {isOpen && (
          <ModalConfirm
            title={
              <div style={{ whiteSpace: 'pre-line' }}>
                {`현재 작성중인 프로필이 있어요! \n 정말 그만두시겠어요?`}
              </div>
            }
            contents=""
            cancelText="계속 작성할게요"
            confirmText="다음에 작성할게요"
            handleClose={onClose}
            onClickConfirm={() => navigate(PATH.ONBOARD)}
          />
        )}
        <S.Wrapper>
          {onBoardState.step === 1 && <Step1 />}
          {onBoardState.step === 2 && <Step2 />}
          {onBoardState.step === 3 && <Step3 />}
          {onBoardState.step === 4 && <Step4 />}
          {onBoardState.step === 5 && <Step5 />}
          {onBoardState.step === 6 && <Step6 />}
          {onBoardState.step === 7 && <Step7 />}
          {onBoardState.step === 8 && <Step8 />}
          {onBoardState.step === 9 && <Step9 />}
        </S.Wrapper>
      </PrevHeaderBarWithTitleTemplate>
    </>
  );
}
